import { useParams } from 'react-router-dom';
import PasswordInput from '@/common/components/auth/PasswordInput';
import {
	Actions,
	BrandMark,
	BrandRow,
	Message,
	PageShell,
	PrimaryButton,
	StatusCard,
	StatusPill,
	Title,
} from '@/pages/orderStatusPage/orderStatusPage.styles';
import {
	Form,
	FormError,
	FormField,
	FormHint,
	FormLabel,
	PrimaryLink,
	SecondaryLink,
} from './restartPasswordPage.styles';
import { useRestartPasswordPage } from './hooks/useRestartPasswordPage';

const RestartPasswordPage = () => {
	const { token = '' } = useParams();
	const {
		t,
		password,
		setPassword,
		passwordRepeat,
		setPasswordRepeat,
		formError,
		phase,
		isSubmitting,
		handleSubmit,
	} = useRestartPasswordPage(token);

	return (
		<PageShell>
			<StatusCard $phase={phase === 'success' ? 'success' : phase === 'invalid' ? 'failed' : 'verifying'}>
				<BrandRow>
					<BrandMark>Soft AI</BrandMark>
					<StatusPill $phase={phase === 'success' ? 'success' : phase === 'invalid' ? 'failed' : 'verifying'}>
						{phase === 'loading' && t.statusLoading}
						{phase === 'form' && t.statusReady}
						{phase === 'success' && t.statusSuccess}
						{phase === 'invalid' && t.statusInvalid}
					</StatusPill>
				</BrandRow>
				{phase === 'loading' && (
					<>
						<Title>{t.loadingTitle}</Title>
						<Message>{t.loadingMessage}</Message>
					</>
				)}
				{phase === 'invalid' && (
					<>
						<Title>{t.invalidTitle}</Title>
						<Message>{t.invalidMessage}</Message>
						<Actions>
							<SecondaryLink to="/">
								{t.backToApp}
							</SecondaryLink>
						</Actions>
					</>
				)}
				{phase === 'success' && (
					<>
						<Title>{t.successTitle}</Title>
						<Message>{t.successMessage}</Message>
						<Actions>
							<PrimaryLink to="/">
								{t.backToApp}
							</PrimaryLink>
						</Actions>
					</>
				)}
				{phase === 'form' && (
					<>
						<Title>{t.formTitle}</Title>
						<Message>{t.formMessage}</Message>
						<Form onSubmit={handleSubmit}>
							{formError && <FormError>{formError}</FormError>}
							<FormField>
								<FormLabel htmlFor="restart-password-new">{t.passwordLabel}</FormLabel>
								<PasswordInput
									id="restart-password-new"
									value={password}
									onChange={(event) => setPassword(event.target.value)}
									placeholder={t.passwordPlaceholder}
									minLength={6}
									autoFocus
									showPasswordLabel={t.showPassword}
									hidePasswordLabel={t.hidePassword}
									autoComplete="new-password"
									disabled={isSubmitting}
								/>
								<FormHint>{t.passwordRequirements}</FormHint>
							</FormField>
							<FormField>
								<FormLabel htmlFor="restart-password-repeat">{t.confirmPasswordLabel}</FormLabel>
								<PasswordInput
									id="restart-password-repeat"
									value={passwordRepeat}
									onChange={(event) => setPasswordRepeat(event.target.value)}
									placeholder={t.confirmPasswordPlaceholder}
									minLength={6}
									showPasswordLabel={t.showPassword}
									hidePasswordLabel={t.hidePassword}
									autoComplete="new-password"
									disabled={isSubmitting}
								/>
							</FormField>
							<Actions>
								<PrimaryButton type="submit" disabled={isSubmitting}>
									{isSubmitting ? t.submitting : t.submitButton}
								</PrimaryButton>
							</Actions>
						</Form>
					</>
				)}
			</StatusCard>
		</PageShell>
	);
};

export default RestartPasswordPage;
